import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useMemo } from 'react';
import { ChakraProvider } from '@chakra-ui/react';
import { CSSReset } from '@theme/css-reset';
import { CustomStylesLoader } from '@theme/custom-styles-loader';
import { RootStyles } from '@theme/root-styles';
import { ROOT_CLASSNAME, ROOT_SELECTOR } from '@view/constants/root';
import BaseTheme from '@view/theme';
export const ThemeProvider = ({ children, colors, disableCssTitleReset = false, isImmersiveExperience, }) => {
    const theme = useMemo(() => (Object.assign(Object.assign({}, BaseTheme), { colors: Object.assign(Object.assign({}, BaseTheme.colors), (colors || {})) })), [colors]);
    return (_jsxs(ChakraProvider
    // @TECHDEBT: Css vars root by default is the [data-theme] which seems to be applied to the html tag by Chakra
    // Css vars should be applied only to ROOT_SELECTOR and portals should be children of it
    // cssVarsRoot={ROOT_SELECTOR}
    , { 
        // @TECHDEBT: Css vars root by default is the [data-theme] which seems to be applied to the html tag by Chakra
        // Css vars should be applied only to ROOT_SELECTOR and portals should be children of it
        // cssVarsRoot={ROOT_SELECTOR}
        disableGlobalStyle: true, resetCSS: false, theme: theme, children: [_jsx(RootStyles, {}), _jsx(CSSReset, { disableCssTitleReset: disableCssTitleReset, scope: "reach-portal" }), _jsx(CSSReset, { disableCssTitleReset: disableCssTitleReset, scope: `.${ROOT_CLASSNAME}` }), _jsx(CSSReset, { disableCssTitleReset: disableCssTitleReset, scope: ROOT_SELECTOR }), isImmersiveExperience ? _jsx(CustomStylesLoader, {}) : null, children] }));
};
